import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ResourceGroupSelector.css';

const ResourceGroupSelector = ({ onChange, currentOrganization, resourceGroups = [], currentResourceGroup, isLoading = false }) => {
  const { t } = useTranslation();
  const [currentGroup, setCurrentGroup] = useState(currentResourceGroup || null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setCurrentGroup(currentResourceGroup || null);
  }, [currentResourceGroup]);

  const handleSelectResourceGroup = (group) => {
    setCurrentGroup(group);
    setIsOpen(false);
    localStorage.setItem('currentResourceGroupId', group.id.toString());

    // Notify parent component
    if (onChange) {
      onChange(group);
    }
  };

  if (isLoading) {
    return (
      <div className="rg-selector-loading">
        {t('loading')}...
      </div>
    );
  }

  if (!currentOrganization || resourceGroups.length === 0) {
    return null;
  }

  return (
    <div className="rg-selector">
      <button
        className="rg-selector-button"
        onClick={() => resourceGroups.length > 1 && setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="rg-info">
          {currentGroup ? (
            <span className="rg-name">{currentGroup.organization_name} - {currentGroup.name}</span>
          ) : (
            <span className="rg-name">{t('select_resource_group')}</span>
          )}
        </div>
        {resourceGroups.length > 1 && (
          <svg
            className={`rg-selector-arrow ${isOpen ? 'open' : ''}`}
            width="12"
            height="12"
            viewBox="0 0 12 12"
          >
            <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="2" fill="none" />
          </svg>
        )}
      </button>

      {isOpen && (
        <>
          <div
            className="rg-selector-overlay"
            onClick={() => setIsOpen(false)}
          />
          <div className="rg-selector-dropdown">
            {resourceGroups.map(group => (
              <button
                key={group.id}
                className={`rg-option ${currentGroup?.id === group.id ? 'active' : ''}`}
                onClick={() => handleSelectResourceGroup(group)}
              >
                <div className="rg-info">
                  <span className="rg-name">{group.organization_name} - {group.name}</span>
                </div>
                {group.description && (
                  <span className="rg-description">{group.description}</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ResourceGroupSelector;
